import { Fragment as KeyboardAwareScrollView } from 'react';

export default KeyboardAwareScrollView;